import React, {useEffect, useState} from "react";
import Select from "react-select";

export const ACTIVITY_CATEGORY_EXTRAESCOLAR_ID = 1;
export const ACTIVITY_CATEGORY_CAMPAMENTO_ID = 2;

interface Props {
    value: any,
    onChange: (newValue: any) => void,
    classes?: string,
    disabled?: boolean
}

export const ActivityCategorySelect : React.FC<Props> = (props) => {

    const [value, setValue] = useState<any>(null)
    const options = [
        {
            label: "Extraescolar",
            value: ACTIVITY_CATEGORY_EXTRAESCOLAR_ID
        },
        {
            label: "Campamento",
            value: ACTIVITY_CATEGORY_CAMPAMENTO_ID
        }
    ]

    useEffect(() => {
        if(!props.value) {
            return
        }

        const values = options.filter(option => option.value === props.value)
        setValue(values[0] ?? null)
    }, [props.value])

    const onChange = (option: any) => {
        setValue(option)
        props.onChange(option)
    }

    return (
        <Select
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={onChange}
            className={props.classes ?? ''}
            value={value}
            isDisabled={props.disabled ?? false}
        />
    )
}
